import { render, staticRenderFns } from "./AboutUser.vue?vue&type=template&id=3996c6ac&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./AboutUser.vue?vue&type=style&index=0&id=3996c6ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3996c6ac",
  null
  
)

export default component.exports